export default class KeyVaultConstants {
  static readonly SecretCoppied = 'Secret value coppied to clipboard';
  static readonly KeyNameHelperText =
    'Invalid input. Only alphanumeric characters and hyphens are allowed.';
  static readonly KeyNameError = 'Key should satisfy the requirement';
  static readonly KeyEditSuccess = 'Key Value Edited Successfully!';
  static readonly KeySaveSuccess = 'Key Value Saved Successfuly !';
  static readonly KeyDelSuccess = 'Key Deleted Successfuly !';
}
